import { useQuery } from '@tanstack/react-query'
import { appendQueryParamsToURL, getCredentialsConfig } from '@/common/src/helpers/requestHelper'
import { useStore } from 'react-redux'

export type PublicTemplate = {
  category: string
  description: string
  downloads: number
  id: number
  image: string
  image_url: string | null
  key: string
  name: string
  project: string // resource_uri
  readonly: string // URL to view the template in readonly mode
  resource_uri: string
  short_description: string
}

export const usePublicProjectTemplateSearch = ({ text }: { text: string }, enabled = true) => {
  const store = useStore()
  return useQuery({
    enabled,
    queryKey: ['projectTemplates', 'public', { text }],
    queryFn: async ({ signal }) => {
      const response = await fetch(
        appendQueryParamsToURL('/api/v1/public_template/search/', { text })(store.getState()),
        {
          signal,
          credentials: getCredentialsConfig(),
        }
      )
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return (await response.json()) as PublicTemplate[]
    },
    staleTime: 1000 * 60 * 60,
  })
}
